var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "490.877 3221.21 80 98.351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a8a8a8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "application",
    transform: "translate(490.877 3221.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    className: "cls-1",
    d: "M119.677,3.934A3.931,3.931,0,0,0,115.743,0H43.634A3.961,3.961,0,0,0,39.7,3.934V94.417a3.946,3.946,0,0,0,3.934,3.934h72.132a3.931,3.931,0,0,0,3.934-3.934l-.023-90.483ZM46.642,7.382h66.231v83.8H46.642Z",
    transform: "translate(-39.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    className: "cls-1",
    d: "M158.34,99.2H122.934a3.934,3.934,0,1,0,0,7.868H158.34a3.934,3.934,0,1,0,0-7.868Z",
    transform: "translate(-100.649 -76.244)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    className: "cls-1",
    d: "M158.34,189.8H122.934a3.934,3.934,0,1,0,0,7.868H158.34a3.934,3.934,0,1,0,0-7.868Z",
    transform: "translate(-100.649 -145.877)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    className: "cls-1",
    d: "M158.34,286.2H122.934a3.934,3.934,0,1,0,0,7.868H158.34a3.934,3.934,0,1,0,0-7.868Z",
    transform: "translate(-100.649 -219.969)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.b9edc78b4a1cfb8aef3fd42bc1c42188.svg";
export { ForwardRef as ReactComponent };